<template>
  <div class="wrapper">
    <div class="header">
      <div class="main">
        <!-- 用户中心 -->
        <img class="setting" src="@/assets/images/icon-setting.png" @click="jumpSetting"/>
        <div class="user-body">
            <img class="user-pic" src="@/assets/images/user.png" >
            <div class="user-info">
                <p>默认用户</p>
            </div>
        </div>
      </div>
    </div>
    <div class="fill"></div>
  </div>
</template>

<script>
import User from '../../views/user/index.vue'
export default {
    name:'UserHead',
    props: {
    },
    data() {
        return {
        };
    },
    created() {
    },
    methods: {
        jumpSetting(){
            this.$router.push("/setting");
        }
    },
    components: { User }
}
</script>

<style lang="less" scoped>
.wrapper {
  .header {
    width: 100%;
    height: 177px;
    background: url(../../assets/imgs/top-bj.png) no-repeat center/100% 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10;
    box-sizing: border-box;
    padding: 5px 13px 12px 13px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
     
    .main {
        position: relative;
        width: 100%;
        height: 100%;
       .setting {
            display: inline-block;
            width: 19px;
            height: 19px;
            position: absolute;
            top: 50px;
            right: 0;
        }
      .user-body {
        position: absolute;
        left: 0;
        right: 0;
        padding: 26px 15px 31px;
        bottom: -50px;
        display: flex;
        background: #FFFFFF;
        box-shadow: 0px 4px 5px 0px rgba(227,222,222,0.5000);
        border-radius: 7px;
        .user-pic {
            margin-right: 23px;
            width: 62px;
            height: 62px;
            border-radius: 31px;
        }
        .user-info {

        }

      }
    }
  }
}
</style>